import React from 'react'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import { useNavigate } from 'react-router-dom'
import MediaWithShimmer from './MediaWithShimmer'

import galleryVideo from '../images/123.mp4'

const WhiteCoutureGallery = () => {
  const { language } = useLanguage()
  const t = translations.whiteCouture
  const navigate = useNavigate()

  return (
    <section
      className="bg-white cursor-pointer"
      onClick={() => navigate('/shop')}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-[1.05fr_0.95fr] gap-10 items-center">
          {/* Left: video block (on desktop), bottom on mobile */}
          <div className="order-2 md:order-1 relative group rounded-[2.5rem] overflow-hidden border border-[#CEA15F]/60 shadow-[0_0_60px_rgba(206,161,95,0.25)]">
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent pointer-events-none" />
            <MediaWithShimmer
              type="video"
              src={galleryVideo}
              className="w-full h-full object-cover scale-105 transition-transform duration-[5000ms] group-hover:scale-110"
              autoPlay
              loop
              muted
              playsInline
            />
            <div className="absolute inset-0 border border-white/10 rounded-[2.5rem] pointer-events-none" />
          </div>

          {/* Right: photos (on desktop), top on mobile */}
          <div className="order-1 md:order-2 flex flex-col gap-6 md:gap-8 max-w-xl md:ml-auto">
            <div className="grid grid-cols-1 gap-3 md:gap-4 mt-2">
              <div className="grid grid-cols-2 gap-3 md:gap-4 md:col-span-2">
                <div className="h-auto md:h-96 lg:h-[30rem]">
                  <MediaWithShimmer
                    src="https://sun9-61.userapi.com/s/v1/ig2/bqCKV1F7x8mUPxQJiJkf2g-ARvX6kKTGeYtyxkS1bKzbqSL1eypLUK2shO5w6iJezd1kexBEs3ufUfHL7szAUjNB.jpg?quality=95&as=32x45,48x68,72x102,108x153,160x227,240x340,360x510,480x680,540x765,640x907,720x1020,1071x1518&from=bu&cs=1071x0"
                    alt="White Collection"
                    className="w-full h-full object-cover object-center rounded-xl shadow-md"
                  />
                </div>
                <div className="h-auto md:h-96 lg:h-[30rem]">
                  <MediaWithShimmer
                    src="https://sun9-33.userapi.com/s/v1/ig2/R2JZrZ7pA62cIeHAp98gouEFlCInVnyK55IgyJa-0T1mgarEwqVpjai3DScNT0ORgGXghtKnbCDhhZH5yl7ZgSj6.jpg?quality=95&as=32x36,48x54,72x81,108x121,160x179,240x269,360x403,480x537,540x605,640x717,720x806,1080x1209,1280x1433,1428x1599&from=bu&cs=1428x0"
                    alt="White Couture"
                    className="w-full h-full object-cover object-center rounded-xl shadow-md"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhiteCoutureGallery
